import { jsx as _jsx } from "react/jsx-runtime";
import 'react';
import classNames from 'classnames';
// @ts-ignore-next-line 7016
import { NotificationContainer } from 'react-notifications';
const NotificationsContainer = ({ stacked }) => {
    const wrapperClasses = classNames('notification-container-wrapper', stacked && 'stacked');
    return (_jsx("div", Object.assign({ className: wrapperClasses }, { children: _jsx(NotificationContainer, {}) })));
};
export default NotificationsContainer;
